/**
 *
 * key
 *
 */

 const key = 'bGVhZE1ldHJpY3M='

 export default key
 